// src/pages/container_rental/components/RoundStatusChip.tsx
//
// 회차 상태 칩 — StatusChip.tsx 와 동일한 소프트 칩 언어를 쓴다.
//  · radius 6 / 미세 보더 / 옅은 틴트 배경 / 도트 + 한글 단독 라벨
//  · 상태 의미색은 유지(signal=발행 완료, amber=건너뜀, stop=취소, 중립=예정)
//
// 구 구현은 MUI <Chip color="success|warning|error" variant="filled"> 라
// 의미색 원색이 꽉 찬 솔리드 칩이었고, 같은 화면의 StatusChip · TimelineLegend
// 스와치(옅은 틴트)와 색 밀도가 어긋났다.
// props 시그니처(status / size / sx)는 그대로라 사용처는 바뀌지 않는다.

import { Box } from "@mui/material";
import { designTokens } from "../../../theme.ts";
import { RoundStatus } from "../../../contracts/container_rental/types.ts";

const T = designTokens;

interface RoundStatusChipProps {
  status: RoundStatus;
  size?: "small" | "medium";
  sx?: any;
}

const ROUND_CONF: Record<
  RoundStatus,
  { ko: string; bg: string; fg: string; dot: string; border: string }
> = {
  scheduled: { ko: "예정",      bg: "#F2F4F5", fg: "#4A5057", dot: "#9AA0A6", border: "#E4E7EA" },
  issued:    { ko: "발행 완료", bg: "#E7F2EA", fg: "#1F6535", dot: T.signal,  border: "#CFE4D6" },
  skipped:   { ko: "건너뜀",    bg: "#FCF3E4", fg: "#8A5C12", dot: T.amber,   border: "#F1E0C2" },
  cancelled: { ko: "취소",      bg: "#FBEDED", fg: T.stop,    dot: T.stop,    border: "#F0D6D6" },
};

export default function RoundStatusChip({
  status,
  size = "small",
  sx,
}: RoundStatusChipProps) {
  const conf = ROUND_CONF[status] ?? ROUND_CONF.scheduled;

  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.6,
        height: size === "small" ? 22 : 26,
        px: 0.85,
        borderRadius: "6px",
        border: `1px solid ${conf.border}`,
        bgcolor: conf.bg,
        color: conf.fg,
        fontFamily: T.fonts.sans,
        fontWeight: 600,
        fontSize: size === "small" ? 11.5 : 12.5,
        lineHeight: 1,
        letterSpacing: 0,
        whiteSpace: "nowrap",
        flexShrink: 0,
        ...sx,
      }}
    >
      <Box
        component="span"
        sx={{
          width: 6,
          height: 6,
          borderRadius: "50%",
          bgcolor: conf.dot,
          flexShrink: 0,
        }}
      />
      {conf.ko}
    </Box>
  );
}
